import { ApiResponse } from 'apisauce';

import { IAdminGateway } from './adminBase';

import { GatewayResponse, ProtectedRoute } from '~types/gateway';
import {
    TCreateNewRoleAPIParams,
    TEditRoleDetailsAPIParams,
    TGetAdminListingAPIParams,
    TGetAdminListingAPIResponse,
    TRoleFilter,
    TGetRoleListingAPIParams,
    TGetRoleListingAPIResponse,
    TGetUserDetailsAPIParams,
    TGetUserDetailsAPIResponse,
    TCreateNewAdminAPIParams,
    TEditAdminDetailsAPIParams,
    TExportAdminUserListingAPIResponse,
    TExportAdminRoleListingAPIResponse,
    TExportAdminUserListingAPIParams,
} from '~types/feat/admin';

import UtilFunctions from '~utils/functions';

const { API: { getHeaders } } = UtilFunctions;
export default class AdminGateway extends IAdminGateway {
    async getAdminListing(params: TGetAdminListingAPIParams): GatewayResponse<TGetAdminListingAPIResponse> {
        const { authToken, ...restOfGetAdminListingAPIParams } = params;
        const response: ApiResponse<TGetAdminListingAPIResponse> = await this.api.get('/rbac/getAuthUserListing', restOfGetAdminListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getRoleListing(params: TGetRoleListingAPIParams): GatewayResponse<TGetRoleListingAPIResponse> {
        const { authToken, ...restOfGetRoleListingAPIParams } = params;
        const response: ApiResponse<TGetRoleListingAPIResponse> = await this.api.get('/rbac/getRoleListing', restOfGetRoleListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async createNewRole(params: TCreateNewRoleAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfCreateNewRoleAPIParams } = params;
        const response: ApiResponse<null> = await this.api.post('/rbac/createRole', restOfCreateNewRoleAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async editRoleDetails(params: TEditRoleDetailsAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfEditRoleDetailsAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/rbac/updateRole', restOfEditRoleDetailsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getUserDetails(params: TGetUserDetailsAPIParams): GatewayResponse<TGetUserDetailsAPIResponse> {
        const { authToken, ...restOfGetUserDetailsAPIParams } = params;
        const response: ApiResponse<TGetUserDetailsAPIResponse> = await this.api.get('/rbac/getAuthUserDetails', restOfGetUserDetailsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getAllRoles(params: ProtectedRoute): GatewayResponse<TRoleFilter[]> {
        const { authToken } = params;
        const response: ApiResponse<TRoleFilter[]> = await this.api.get('/rbac/getRoleFilter', {}, getHeaders(authToken));
        return this.process(response);
    }

    async createNewAdmin(params: TCreateNewAdminAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfCreateNewAdminAPIParams } = params;
        const response: ApiResponse<null> = await this.api.post('/rbac/createAuthUser', restOfCreateNewAdminAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async editAdminDetails(params: TEditAdminDetailsAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfEditAdminDetailsAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/rbac/updateAuthUser', restOfEditAdminDetailsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async exportAdminUserListing(params: TExportAdminUserListingAPIParams): GatewayResponse<TExportAdminUserListingAPIResponse[]> {
        const { authToken, ...restOfExportAdminUserListingAPIParams } = params;
        const response: ApiResponse<TExportAdminUserListingAPIResponse[]> = await this.api.get(
            '/rbac/exportUserList',
            restOfExportAdminUserListingAPIParams,
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async exportAdminRoleListing(params: ProtectedRoute): GatewayResponse<TExportAdminRoleListingAPIResponse[]> {
        const { authToken } = params;
        const response: ApiResponse<TExportAdminRoleListingAPIResponse[]> = await this.api.get(
            '/rbac/exportRoleList',
            {},
            getHeaders(authToken)
        );
        return this.process(response);
    }

}
